/**
 * Product-analytics event names for the mobile web app, as they appear in PostHog.
 *
 * Same convention as the desktop enum (`frontend/src/interfaces/BI/BIEventNames.enum.ts`):
 * `domain_object_action`, snake_case, past tense — with a `mobile_` domain prefix, because both
 * apps report into the SAME PostHog project and several events exist on both surfaces
 * (issues, notifications, view settings). The prefix is what keeps "issue created on mobile"
 * separable from "issue created on desktop".
 *
 * Normalised in one pass while the destination had no history; see the desktop enum's note on
 * why renaming is free exactly once and is not free from here.
 */
export enum BIEventNames {
	// Shell
	'appBecameVisible' = 'mobile_app_focused',

	// Onboarding / interests
	'welcomeScreenInterestsDefinitions' = 'mobile_welcome_interests_defined',
	'myInterestsDefinitions' = 'mobile_interests_updated',

	// Module access
	'workersMobileAccess' = 'mobile_workers_viewed',
	'equipmentMobileAccess' = 'mobile_equipment_viewed',
	'activitiesMobileAccess' = 'mobile_activities_viewed',
	'preferencesMobileAccess' = 'mobile_preferences_viewed',

	// View settings
	'viewSettingsOpen' = 'mobile_workers_view_settings_opened',
	'viewSettingsUpdate' = 'mobile_workers_view_settings_updated',
	'activitiesViewSettingsOpen' = 'mobile_activities_view_settings_opened',
	'activitiesViewSettingsUpdate' = 'mobile_activities_view_settings_updated',

	// Issues
	'issuesTabAccess' = 'mobile_issues_viewed',
	'issueCreate' = 'mobile_issue_created',
	'issueEdit' = 'mobile_issue_updated',
	'issueStatusChange' = 'mobile_issue_status_changed',
	'issueComment' = 'mobile_issue_comment_created',

	// Workplan
	'workplanActivityActions' = 'mobile_workplan_matrix_interacted',

	// Notifications
	'notificationsMobileAccess' = 'mobile_notification_center_viewed',
	'notificationSettingsTabAccess' = 'mobile_notification_settings_viewed',
	'notificationsSettingsPreferencesEngagement' = 'mobile_notification_preferences_engaged',
	'pushNotificationDialogShown' = 'mobile_push_dialog_shown',
	'pushNotificationDialogAction' = 'mobile_push_dialog_actioned',
	'pushNotificationNativeDialogAction' = 'mobile_push_native_dialog_actioned',
}
